export default "__VITE_ASSET__De8NC$ZJ__"